module.exports = __webpack_public_path__ + "static/media/wasserleitung_detail.1a7007b6.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/wasserleitung_detail.JPG
// module id = 779
// module chunks = 0